var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIbArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.862 2.529c.26-.26.682-.26.943 0l4 4a.666.666 0 010 .942l-4 4a.667.667 0 11-.943-.942l2.862-2.862H1.667a.667.667 0 010-1.334h9.057L7.862 3.471a.667.667 0 010-.942z",
    fill: "#ED1B2E"
  })));
}

export default SvgIbArrowRight;